import $, { data } from "jquery"
import { TextField } from "@mui/material"
import { IsAlert } from '../../atoms/IsAlert';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useState } from "react";
import { fetchApi } from "../../../helper/api";

const SettingTreshold = (props) => {
    console.log(props);
    const validationSchema = Yup.object().shape({
        thresholdWarningMax_x: Yup.string().required('Kolom harus diisi'),
        thresholdWarningMax_y: Yup.string().required('Kolom harus diisi'),
        thresholdWarningMax_z: Yup.string().required('Kolom harus diisi'),
        thresholdWarningMin_x: Yup.string().required('Kolom harus diisi'),
        thresholdWarningMin_y: Yup.string().required('Kolom harus diisi'),
        thresholdWarningMin_z: Yup.string().required('Kolom harus diisi'),
        thresholdDangerMax_x: Yup.string().required('Kolom harus diisi'),
        thresholdDangerMax_y: Yup.string().required('Kolom harus diisi'),
        thresholdDangerMax_z: Yup.string().required('Kolom harus diisi'),
        thresholdDangerMin_x: Yup.string().required('Kolom harus diisi'),
        thresholdDangerMin_y: Yup.string().required('Kolom harus diisi'),
        thresholdDangerMin_z: Yup.string().required('Kolom harus diisi'),
        offset_x: Yup.string().required('Kolom harus diisi'),
        offset_y: Yup.string().required('Kolom harus diisi'),
        offset_z: Yup.string().required('Kolom harus diisi'),
        gain_x: Yup.string().required('Kolom harus diisi'),
        gain_y: Yup.string().required('Kolom harus diisi'),
        gain_z: Yup.string().required('Kolom harus diisi'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };
    const { register, handleSubmit, watch, formState: { errors } } = useForm(formOptions);
    const [dataPost, setDataPost] = useState(props.data.sensorProps)
    const handleSave = async () => {
        console.log(dataPost);
        var data = {
            ipcSerialNumber: props.data.idIpc,
            sensorProps : dataPost,
            sensorId : props.data.idSensor
        }
        var req = await fetchApi('api/Rtu/updateProps','PUT', true, data)
        var res = await req.json()
        var status = req.status
        if (status === 200) {
            IsAlert.fire({
                title: "Berhasil",
                text: "Treshold berhasil di update",
                icon: "success",
                showCancelButton: false,
                focusConfirm: true,
                confirmButtonText: 'OK',
                showCancelButton: false
    
            }).then(function (isConfirm) {
                if (isConfirm.isConfirmed) {
                    props.callback()
                    $(".close").click()
                }
            })
        }
        else{
            IsAlert.fire({
                title: res.status,
                text: res.message,
                icon: "error",
                showCancelButton: false,
                focusConfirm: true,
                confirmButtonText: 'OK',
                showCancelButton: false
    
            }).then(function (isConfirm) {
                if (isConfirm.isConfirmed) {
                    $(".close").click()
                }
            })
        }
    }
    const handleChange = (tipe, axis, value) => {
        dataPost.map((e,i) => {
            if (e.type === tipe) {
                e.values.map((d,n) => {
                    if (d.axis === axis) {
                        var databaru = dataPost
                        databaru[i].values[n].value = parseFloat(value)
                        setDataPost(databaru)
                    }
                })
            }
        })
    }
    return (
        <div
            className="modal fade"
            id="SettingTreshold_modal"
            tabIndex={-1}
            aria-labelledby="SettingTreshold_modalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="d-flex align-items-center">
                            <h5 className="mb-0 ml-2">Ubah Pengaturan Treshold</h5>
                        </div>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body py-4">
                        {
                            dataPost.map((e, i) => {
                                return (
                                    <div className="border-bottom pb-2" key={i}>
                                        <h1 className="my-3">{e.type}</h1>
                                        <div className='row'>
                                            {
                                                e.values.map((d, n) => {
                                                    var jumlah = e.values.length
                                                    return (
                                                        <div className={`col-lg-${12 / jumlah} mb-3`} key={n}>
                                                            <TextField
                                                                color="success"
                                                                // error={errors.email ? true : false}
                                                                // helperText={errors.email ? errors.email.message : ""}
                                                                // {...register("email")}
                                                                defaultValue={d.value}
                                                                // value={d.value}
                                                                label={d.axis}
                                                                className="w-100"
                                                                type="text"
                                                                onChange={(event) => {
                                                                    handleChange(e.type, d.axis, event.target.value)
                                                                }}
                                                            />
                                                        </div>
                                                    )
                                                })
                                            } 
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleSave}
                        >
                            Simpan
                        </button>
                        <button
                            type="button"
                            className="btn btn-light"
                            data-dismiss="modal"
                        >
                            Batal
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SettingTreshold